export const assetsUrl = "https://assets.yiwoaikeji.com/prod/official-website-assets/";